import { createFileRoute } from "@tanstack/react-router";
import { LOCALE_FAQ } from "@/data/faq/locale-copy";
import { buildLocaleFaqHead } from "@/lib/faq/locale-head";
import { LocaleFaqPage } from "@/components/faq/LocaleFaqPage";

export const Route = createFileRoute("/vi/faq")({
  loader: () => ({ h: buildLocaleFaqHead("vi", LOCALE_FAQ.vi) }),
  head: ({ loaderData }) => loaderData?.h ?? {},
  component: () => <LocaleFaqPage copy={LOCALE_FAQ.vi} />,
});
